export default "__VITE_ASSET__B4T8bQm___"